import { InjectionToken } from '@angular/core';

import type { CustomerLookupStrategy } from './strategies/customer-lookup.strategy';

/**
 * Injection token that can be used to provide the implementation
 * for the CustomerLookupStrategy.
 */
export const CUSTOMER_LOOKUP_STRATEGY =
  new InjectionToken<CustomerLookupStrategy>('CUSTOMER_LOOKUP_STRATEGY');
